import { render, staticRenderFns } from "./TextEdit.vue?vue&type=template&id=489e4d5b&scoped=true&"
import script from "./TextEdit.vue?vue&type=script&lang=js&"
export * from "./TextEdit.vue?vue&type=script&lang=js&"
import style0 from "./TextEdit.vue?vue&type=style&index=0&id=489e4d5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489e4d5b",
  null
  
)

export default component.exports